export default __webpack_public_path__ + "static/media/strategy.a581e8c3.jpg";